import React, { useEffect, useMemo } from 'react';
import VagueSearchSelected from '../../components/VagueSearchSelected';
import { useIntl } from 'umi';
import { initialUpperCase } from '@op/utils';
import { useInputFocus } from '../../hooks/common';

export default function SystemRecommendations({
  basicOptions,
  values,
  setValues,
  vagueValues,
  setVagueValues,
  excludeValues,
  setExcludeValues,
  debounceGetFilterList,
  loading,
  setLoading,
  total,
}: {
  basicOptions: any;
  values: string[];
  setValues: any;
  vagueValues: string[];
  setVagueValues: any;
  excludeValues: string[];
  setExcludeValues: any;
  debounceGetFilterList: any;
  loading: any;
  setLoading: any;
  total?: number;
}) {
  const { formatMessage } = useIntl();
  const options = useMemo(() => {
    // const defaultSelect = values || [];
    // let flag = defaultSelect.length >= 10;
    let basicKeyword =
      basicOptions?.map((item: { keyword: any }) => item.keyword) || [];

    return basicKeyword.map((info: any) => {
      // const disabled = flag && !defaultSelect.includes(info);
      const value = initialUpperCase(info);
      return {
        text: value,
        value: value,
        // disabled,
      };
    });
  }, [basicOptions]);

  const inputProps = useInputFocus();

  useEffect(() => {
    inputProps.onFocus();
    options.length === 0 && debounceGetFilterList('', { top_n: 10 });
  }, []);

  return (
    <VagueSearchSelected
      values={values}
      vagueValues={vagueValues}
      setVagueValues={setVagueValues}
      excludeValues={excludeValues}
      setExcludeValues={setExcludeValues}
      loading={loading}
      setLoading={setLoading}
      basicOptions={options}
      setValues={setValues}
      total={total}
      getFilterList={debounceGetFilterList}
      topTips={
        'Select from system-recommended keywords, including translations and synonyms, for quick results.'
      }
      placeholderText={'Search'}
      mainText={'Keywords'}
      searchListFooterText={
        'To enhance search efficiency, the list only displays the top 100 keywords.'
      }
      {...inputProps}
    ></VagueSearchSelected>
  );
}
